{
  "collectionLabel": "Предложения"
}
